import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import defaultImage from "assets/images/white.jpg";
import { colors } from "common/const/colors";
import { useApiRequest } from "common/utils/api";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { ImagePreview } from "../Button/new/ImagePreview";
import { Column, Row } from "../Layout/new/constLayout";
import { TextButton2, TextPlaceholder, TextTitle2 } from "..";

const HomeCCCard = ({ item }) => {
  const { data } = useApiRequest({
    method: REQUEST_METHOD.GET,
    url: `/api/v2.0/club?clubId=${item.id}`,
  });
  const clubData = data?.club;

  return (
    <HomeCardLayout
      onClick={() => {
        if (!clubData) return;
        window.setClub(item.id);
        localStorage.setItem("clubId", clubData.id);
        localStorage.setItem("country", clubData.country);
        localStorage.setItem("currency", clubData.currencyCode);
        localStorage.setItem("clubName", clubData.name);
      }}
      to={"/insights"}
      style={{
        textDecoration: "none",
      }}>
      <CardImageDiv>
        <ImagePreview
          src={item.attachmentRef ?? item.imageRef ?? defaultImage}
          width={"100%"}
          height={"100%"}
          isVideo={item.attachmentType === "video/mp4"}
          alt="club"
        />
      </CardImageDiv>
      <CardText>
        <Column gap={"0.5rem"}>
          <TextTitle2 color={colors.DarkNavy}>{item.name}</TextTitle2>
          <TextPlaceholder color={colors.DarkNavy}>
            {item.country}
          </TextPlaceholder>
        </Column>
        <Row $align={"flex-end"} $justify={"space-between"}>
          <TextPlaceholder color={colors.LightNavy}>
            {item.roleName}
          </TextPlaceholder>
          {/* <InfoIcon style={{ width: "24px", height: "24px" }} /> */}
        </Row>
      </CardText>
    </HomeCardLayout>
  );
};

const HomeCardLayout = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  min-width: 16rem;
  max-width: 24rem;
  width: 100%;
  aspect-ratio: 49 / 40;
  border: none;
  background-color: var(--White);
  border-radius: var(--border-radius-16);
  box-shadow: var(--box-shadow);
`;

const CardImageDiv = styled.div`
  width: 100%;
  height: 70%;
  overflow: hidden;
  border-top-left-radius: var(--border-radius-16);
  border-top-right-radius: var(--border-radius-16);
  box-sizing: border-box;
`;

const CardText = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
`;

export { HomeCCCard };

/**
 * 범용 카드 컨테이너.
 * @param {Object} props
 * @param {React.ReactNode} [props.title] - 카드 제목
 * @param {React.ReactNode} [props.titleRight] - 제목 오른쪽 액션 슬롯(삭제 버튼 등)
 * @param {React.ReactNode} props.children
 * 나머지 props(style, className 등)는 컨테이너로 전달된다.
 */
export const Card = ({ title, titleRight, children, padding, ...rest }) => {
  return (
    <CardContainer $padding={padding} {...rest}>
      {(title != null || titleRight) && (
        <CardHeader>
          {title != null && <TextButton2>{title}</TextButton2>}
          {titleRight}
        </CardHeader>
      )}
      {children}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.25rem;
  padding: ${({ $padding }) => $padding || "1.5rem"};
  background-color: ${colors.GhostWhite};
  border-radius: var(--border-radius-16);
  box-sizing: border-box;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;
